type RegExpExtendedExecArray = RegExpExecArray & { groups: string };
export const formatPhone = (phone: string): string => {
  const trimmed: string = phone.replace(/ /g, '').trim().trim();
  const regex = /(?<zero>0)?(?<first>7\d{2})?(?<second>\d{2})?(?<third>\d{2})?(?<fourth>\d{2})?(?<fifth>\d+)?/u;
  const {
    groups: { zero, first, second, third, fourth, fifth },
  } = regex.exec(trimmed) as RegExpExtendedExecArray;
  const zeroLength = (zero || '').length;

  if (fifth) {
    // phone number is too long, so we do not format it
    return trimmed;
  }

  if (!first || !second) {
    if (first && first.length < trimmed.length) {
      return `+46 ${first} ${trimmed.slice(first.length + zeroLength)}`;
    }
    return trimmed;
  }

  if (!third) {
    const end = trimmed.slice(first.length + second.length + zeroLength);
    return `+46 ${first} ${second} ${end}`.trim();
  }

  if (!fourth) {
    const end = trimmed.slice(first.length + second.length + third.length + zeroLength);
    return `+46 ${first} ${second} ${third} ${end}`.trim();
  }

  return `+46 ${first} ${second} ${third} ${fourth}`.trim();
};
